import { useEffect, useState } from 'react';
import { PlaybackEvent, PlaybackEventEmitter } from '@annunciate/core';
import { getFormattedProgressAndRemainingTime } from '../..';
export const usePlaybackMetrics = () => {
    const [progress, setProgress] = useState({
        position: 0,
        duration: 0,
    });
    const { position, duration } = progress;
    useEffect(() => {
        const listener = async (p) => {
            setProgress({
                position: p.position,
                duration: p.duration,
            });
        };
        PlaybackEventEmitter.on(PlaybackEvent.PROGRESS_UPDATED, listener);
        return () => {
            PlaybackEventEmitter.off(PlaybackEvent.PROGRESS_UPDATED, listener);
        };
    }, []);
    return getFormattedProgressAndRemainingTime(position, duration);
};
//# sourceMappingURL=usePlaybackMetrics.js.map